export default "__VITE_ASSET__DPnnkxTr__"